import { render, staticRenderFns } from "./E-BillingPortal.vue?vue&type=template&id=48b1f5e4&"
import script from "./E-BillingPortal.vue?vue&type=script&lang=js&"
export * from "./E-BillingPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports